/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { registerLanguage } from '../_.contribution.js';
registerLanguage({
    id: 'pascal',
    extensions: ['.pas', '.p', '.pp'],
    aliases: ['Pascal', 'pas'],
    mimetypes: ['text/x-pascal-source', 'text/x-pascal'],
    loader: function () { return import('./pascal.js'); }
});
